export default {
  mutations: {
    setCurrentGroup: 'setCurrentGroup',
    setRouteLoadingValue: 'setRouteLoadingValue',
  },
  getters: {
    canBooking: 'canBooking',
    canTrial: 'canTrial',
  },
  modules: {
    currentUser: {
      name: 'currentUser',
      actions: {
        getCurrentUser: 'getCurrentUser',
        setCurrentUser: 'setCurrentUser',
        login: 'login',
        logout: 'logout',
      },
    },
    globalSearch: {
      name: 'globalSearch',
      actions: {
        search: 'search',
      },
    },
    reporting: {
      name: 'reporting',
      actions: {
        getBookingReportData: 'getBookingReportData',
        getTrialReportData: 'getTrialReportData',
      },
    },
    notifications: {
      name: 'notifications',
      actions: {
        getNotificationsUnreadCount: 'getNotificationsUnreadCount',
        getNotificationsList: 'getNotificationsList',
        makeAllNotificationsRead: 'makeAllNotificationsRead',
      },
      mutations: {
        updateUnread: 'updateUnread',
      }
    },
    trial: {
      name: 'trial',
      actions: {
        copyTrial: 'copyTrial',
      },
    },
    booking: {
      name: 'booking',
    },
    projects: {
      name: 'projects',
    },
    products: {
      name: 'products',
    },
    plants: {
      name: 'plants',
    },
    teams: {
      name: 'teams',
    },
    technology: {
      name: 'technology',
    },
    processes: {
      name: 'processes',
    },
    brands: {
      name: 'brands',
    },
    trialSets: {
      name: 'trialSets',
    },
    alert: {
      name: 'alert',
    },
    subproducts: {
      name: 'subproducts',
    },
    process: {
      name: 'process',
    },
    processStages: {
      name: 'processStages',
    },
    processSteps: {
      name: 'processSteps',
    },
    ingredientGroups: {
      name: 'ingredientGroups',
    },
    fermentGroups: {
      name: 'fermentGroups',
    },
    recipeModule: {
      name: 'recipeModule',
    },
    recipes: {
      name: 'recipes',
    },
    mixingModule: {
      name: 'mixingModule',
    },
    mixinComponents: {
      name: 'mixinComponents',
    },
    mixins: {
      name: 'mixing',
    },
    premixes: {
      name: 'premixes',
    },
    total: {
      name: 'total',
    },
    mixRecipes: {
      name: 'mixRecipes',
    },
    customIngredients: {
      name: 'customIngredients',
    },
    samplingModule: {
      name: 'samplingModule',
    },
    sampling: {
      name: 'sampling',
    },
    packagings: {
      name: 'packagings',
    },
    documents: {
      name: 'documents',
    },
    comments: {
      name: 'comments',
    },
    analysisComponents: {
      name: 'analysisComponents',
    },
    analysisObject: {
      name: 'analysisObject',
    },
    analysisProducts: {
      name: 'analysisProducts',
    },
    analysis: {
      name: 'analysis',
    },
    analysisDayOfTests: {
      name: 'analysisDayOfTests',
    },
    laboratories: {
      name: 'laboratories',
    },
    analysisClasses: {
      name: 'analysisClasses',
    },
    suggestUsers: {
      name: 'suggestUsers',
    },
    componentSets: {
      name: 'componentSets',
    },
    trialHistory: {
      name: 'trialHistory',
    },
  },
};
